export default __webpack_public_path__ + "assets/f741a0fcc7d4a4cb7ae1f3c8027401ba.png";